import axios from "axios";
import config from "../constants/config";
const XLSX = require("xlsx");

export default {
  methods: {
    async GetAllMasterData () {
      const token = localStorage.getItem("token");
      if (!token) {
        this.$store.dispatch("incident/setMasters", null);
        return false;
      }

      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.DASHBOARD.MASTER_DATA}`
      );
      this.$store.dispatch("incident/setMasters", res.data);

      return true;
    },

    async GetIncidentMasters () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.INCIDENT_MASTER}`
      );

      return res.data;
    },

    async GetAllIncidents (page) {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.INCIDENT_DETAILS}?page=${page}`
      );

      return res.data;
    },

    async GetRpoIncidens (userId) {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.RPO_INCIDENTS}${userId}`
      );

      return res.data;
    },

    async SaveIncident (incidentBody) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.RAISE_INCIDENT}`,
        incidentBody
      );

      return res.data;
    },

    async SaveIncidentImages (formData) {
      const res = await axios({
        method: "post",
        url: `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.UPLOAD_IMAGE}`,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });

      return res.data;
    },

    async ResolveIncident (resolveBody) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.RESOLVE_INCIDENT}`,
        resolveBody
      );

      return res.data;
    },

    async GenerateChallan (resolveBody) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.RAISE_CHALLAN}`,
        resolveBody
      );
      return res.data;
    },

    async ReportIncident (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.REPORT_UPDATE}`,
        body
      );
      return res.data;
    },

    getDateFromCustomDateTime (date) {
      const splitted = date.split("T");
      let d = splitted[0];
      const splitDate = d.split("/");
      return `${splitDate[1]}/${splitDate[0]}/${splitDate[2]}`;
    },

    convertJsontoExcel (indexDetails) {
      const workSheet = XLSX.utils.json_to_sheet(indexDetails);
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, "incident");
      //generate buffer (larger data)
      XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
      //binary string
      XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
      XLSX.writeFile(workBook, "indexDetails.");
    },

    async GetViolationsData () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.VIOLATIONS}`
      );

      return res.data;
    },

    async AddVehicleDetails (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.ADD_VEHICLE}`,
        body
      );
      return res.data;
    },

    async ShowVehicleDetails (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.SHOW_VEHICLE}`,
        body
      );
      return res.data;
    },

    async DeleteVehicleDetails (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.DELETE_VEHICLE}`,
        body
      );
      return res.data;
    },

    async EditVehicleDetails (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.EDIT_VEHICLE}`,
        body
      );
      return res.data;
    },

    async ReportIncident (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.REPORT_INCIDENT}`,
        body
      );
      return res.data;
    },

    async Respond (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.INCIDENTS.REQ_REPONSE}`,
        body
      );
      return res.data;
    },
  },
};
